import Icon from '@/atoms/Icon/Icon';
import Text from '@/atoms/Text/Text';

export default function RecipeOverview({ fields = {} }) {
  const {
    serves,
    duration,
    vegetables,
    cut,
    difficulties,
    description,
    hasMarginBottom,
    backgroundImage,
  } = fields;

  return (
    <div
      className={`aaco-recipe-overview container mx-auto ${
        hasMarginBottom ? 'mb-[60px] md:mb-20' : ''
      } print:mx-0 print:my-5`}
    >
      <div
        className="bg-progressive-blue rounded-[8px] px-8 md:py-24 md:px-40 pt-[51px] pb-[45.67px] print:p-0 print:bg-transparent"
        style={{
          backgroundImage: `url(${backgroundImage?.[0]?.original_secure_url})`,
        }}
      >
        <div className="aaco-recipe-overview__detail">
          <div className="hidden md:grid md:grid-rows-1 md:grid-cols-3 lg:grid-cols-5 print:grid print:grid-cols-5 justify-center">
            <RecipeItem iconName="serves" text={serves} />
            <RecipeItem iconName="duration" text={duration} />
            <RecipeItem iconName="ingredients" text={vegetables} />
            <RecipeItem iconName="cut" text={cut} />
            <RecipeItem iconName="difficulty" text={difficulties} />
          </div>
          <div className="block md:hidden print:hidden">
            <div className="flex justify-between mb-[30px]">
              <RecipeItem iconName="serves" text={serves} />
              <RecipeItem iconName="duration" text={duration} />
              <RecipeItem iconName="ingredients" text={vegetables} />
            </div>
            <div className="flex justify-center gap-x-[41px]">
              <RecipeItem iconName="cut" text={cut} />
              <RecipeItem iconName="difficulty" text={difficulties} />
            </div>
          </div>
        </div>
        <div className="aaco-recipe-overview__description mt-10 md:mt-[50px]">
          <Text style="text-white block text-center print:text-progressive-blue print:text-left">
            {description}
          </Text>
        </div>
      </div>
    </div>
  );
}

function RecipeItem({ iconName, text }) {
  return (
    <div className="aaco-recipe-overview__item flex flex-col gap-y-2 items-center">
      <Icon
        name={iconName}
        className="text-actual-dd-gold w-10 h-10 md:w-[70px] md:h-[70px]"
        width={40}
        height={40}
      />
      <Text tag="body-large-bold" style="text-white">
        {text}
      </Text>
    </div>
  );
}
